"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function forceArray(arr) {
  if (!Array.isArray(arr)) return [arr];
  return arr;
}

exports.default = forceArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/recycle/lib/forceArray.js
// module id = 1512
// module chunks = 57